module.exports = __webpack_public_path__ + "img/crossable-logo.89f054a2.png";